/**
 * tokens.js
 * ─────────────────────────────────────────────────────────────────────────────
 * Central design tokens system for ResumeBar design platform.
 * Defines reusable variables for spacing, radius, typography, borders, and shadows.
 */

export const DESIGN_TOKENS = {
  // Spacing Tokens
  '--spacing-xs': '4px',
  '--spacing-sm': '8px',
  '--spacing-md': '16px',
  '--spacing-lg': '24px',
  '--spacing-xl': '32px',

  // Radius Tokens
  '--radius-sm': '4px',
  '--radius-md': '8px',
  '--radius-lg': '12px',
  '--radius-xl': '16px',

  // Shadow Tokens
  '--shadow-soft': '0 2px 4px rgba(0, 0, 0, 0.05)',
  '--shadow-medium': '0 4px 6px rgba(0, 0, 0, 0.07)',
  '--shadow-large': '0 10px 15px rgba(0, 0, 0, 0.1)',

  // Border Tokens
  '--border-thin': '1px',
  '--border-medium': '2px',
  '--border-thick': '3px',

  // Default Typography Mappings
  '--font-body': '"Inter", "Helvetica Neue", Arial, sans-serif',
  '--font-heading': '"Inter", "Helvetica Neue", Arial, sans-serif',
  '--font-display': '"Inter", "Helvetica Neue", Arial, sans-serif',
  '--line-height-body': '1.45',
  '--line-height-heading': '1.25',
  '--line-height-display': '1.2',
  '--letter-spacing-body': 'normal',
  '--letter-spacing-heading': '0.02em',
  '--letter-spacing-display': '-0.02em'
};

// Spacing & Padding Densities
export const DENSITY_TOKENS = {
  compact: {
    '--spacing-margin': '16px',
    '--spacing-element-gap': '8px',
    '--spacing-paragraph-gap': '4px',
    '--spacing-bullet-gap': '2px',
    '--spacing-section-mb': '10px',
    '--spacing-item-mb': '6px',
    '--line-height-body': '1.3'
  },
  comfortable: {
    '--spacing-margin': '24px',
    '--spacing-element-gap': '16px',
    '--spacing-paragraph-gap': '6px',
    '--spacing-bullet-gap': '4px',
    '--spacing-section-mb': '16px',
    '--spacing-item-mb': '12px',
    '--line-height-body': '1.45'
  },
  luxury: {
    '--spacing-margin': '32px',
    '--spacing-element-gap': '24px',
    '--spacing-paragraph-gap': '10px',
    '--spacing-bullet-gap': '6px',
    '--spacing-section-mb': '24px',
    '--spacing-item-mb': '18px',
    '--line-height-body': '1.6'
  },
  editorial: {
    '--spacing-margin': '28px',
    '--spacing-element-gap': '20px',
    '--spacing-paragraph-gap': '8px',
    '--spacing-bullet-gap': '5px',
    '--spacing-section-mb': '20px',
    '--spacing-item-mb': '14px',
    '--line-height-body': '1.5'
  }
};
